import parse from 'html-react-parser';
import {IPromoListItem} from '@/types';
import {AvatarCircle, Subtitle} from '@/components/atoms';
import {Wrapper} from '@/components/organisms/promoListItem/PromoListItem.Styled';
import {CATEGORY} from '@/const';

const PromoListItem = (props: IPromoListItem) => {
  const {
    lcsBanner,
    compLogoImgUrl,
    supportText,
    compNm,
    promotionDesc1,
    promotionDesc2,
    onClick,
    support,
    type,
  } = props;

  return (
    <>
      {/*{lcsBanner ? (*/}
      {/*  <></>*/}
      {/*) : (*/}
      <Wrapper isLcsBanner={lcsBanner} onClick={onClick}>
        <AvatarCircle src={compLogoImgUrl} alt="promo list avatar"/>
        <Subtitle level={6} color={lcsBanner ? 'primary-100' : 'gray-800'}>
          {lcsBanner
            ? promotionDesc2
            : support === 0 && type === CATEGORY.AF01.toUpperCase()
              ? ''
              : parse(`${supportText ?? ''}`)}
        </Subtitle>
        <Subtitle level={8} color="gray-600">
          {lcsBanner ? promotionDesc1 : compNm}
        </Subtitle>
      </Wrapper>
      {/*)}*/}
    </>
  );
};

export default PromoListItem;
